
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"56","height":"56"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#222"}},[_c('path',{attrs:{"d":"M34.655 52.956H11.86A1.848 1.848 0 0110 51.124V5.832A1.848 1.848 0 0111.86 4h33a1.871 1.871 0 011.34.553 1.79 1.79 0 01.524 1.279V40.7h-8.417a3.668 3.668 0 00-3.652 3.676v8.577zM17.116 40.1a1.832 1.832 0 100 3.663h11.252a1.832 1.832 0 100-3.663zm18.9-7.094a1.831 1.831 0 100 3.662h3.969a1.831 1.831 0 100-3.662zm-18.9 0a1.831 1.831 0 100 3.662H28.36a1.831 1.831 0 10.008-3.662zm18.9-7.1a1.831 1.831 0 100 3.662h3.969a1.831 1.831 0 100-3.662zm-18.9 0a1.831 1.831 0 100 3.662H28.36a1.831 1.831 0 10.008-3.662zm0-16.841a1.847 1.847 0 00-1.86 1.83v8.14a1.848 1.848 0 001.86 1.832h22.5a1.848 1.848 0 001.86-1.832v-8.141a1.847 1.847 0 00-1.86-1.83z"}}),_c('path',{attrs:{"d":"M41.223 43.637h-2.915a.71.71 0 00-.67.742v7.976l8.54-8.414a1.619 1.619 0 00.248-.311h-5.2z"}})])])
          )
        }
      }
    